import { User, UpdateUserPayload } from "@/models/auth/User";
import { VitrinListedCourse } from "@/models/course/VitrinListedCourse";
import { fetchInstance } from "@/utils/fetchInstance";

export class UserService {
  static async getCurrentUser() {
    return fetchInstance<User>(`auth/me`, {
      method: "GET",
      auth: true,
    });
  }

  static async updateCurrentUser(payload: UpdateUserPayload) {
    return fetchInstance<User>(`auth/me`, {
      method: "PUT",
      body: payload,
      auth: true,
    });
  }

  static async getMyCourses(params?: { page?: number; per_page?: number }) {
    const searchParams = new URLSearchParams();
    if (typeof params?.page === "number") {
      searchParams.set("page", String(params.page));
    }
    if (typeof params?.per_page === "number") {
      searchParams.set("per_page", String(params.per_page));
    }
    const query = searchParams.toString();
    return fetchInstance<VitrinListedCourse[]>(
      `vitrin/my-courses${query ? `?${query}` : ""}`,
      {
        method: "GET",
        auth: true,
      },
    );
  }
}
